/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type LlmAdapter =
  | "anthropic"
  | "openai"
  | "azure"
  | "bedrock"
  | "google-vertex-ai"
  | "google-ai-studio";
export const LlmAdapter = {
  Anthropic: "anthropic",
  OpenAi: "openai",
  Azure: "azure",
  Bedrock: "bedrock",
  GoogleVertexAi: "google-vertex-ai",
  GoogleAiStudio: "google-ai-studio",
} as const;
